import * as Api from '@ViewModels';
import { useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../../models/hooks/appStateHooks';
import { reactQueryClient } from '../../../web/ReactQueryProvider';

const BASE_QUERY_KEY = 'automation/<id>';

export function useAutomationQuery({
	id,
	enabled = true,
	impersonationContext,
}: {
	id: string;
	enabled?: boolean;
	impersonationContext?: Api.IImpersonationContext;
}) {
	const userSession = useUserSession();
	return useQuery({
		enabled: enabled && !!id,
		queryFn: () => {
			return userSession.webServiceHelper.callAsync<Api.IAutomation>(
				Api.ImpersonationBroker.composeApiUrl({
					urlPath: `Automation/${encodeURIComponent(id)}`,
					impersonationContext,
				}),
				'GET'
			);
		},
		queryKey: [BASE_QUERY_KEY, id, impersonationContext?.account?.id],
	});
}

export function invalidateAllAutomationQueries() {
	reactQueryClient.invalidateQueries({ queryKey: [BASE_QUERY_KEY] });
}
